export default "__VITE_ASSET__BTHi$1mE__"